// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3H2Ly","messages":"Chat_messages__1amST","dateDivider":"Chat_dateDivider__T2vj2"};